<script setup lang="ts">
import { computed, ref } from 'vue'
import { baseUrl, logTime } from '@/core/utils'
import { config } from '@/core/config'

const show = config.backgroundMusicSettings.show
const autoplay = config.backgroundMusicSettings.autoplay
const playlist = config.backgroundMusicSettings.playlist
const currentIndex = ref(0)

const src = computed(() => baseUrl(playlist[currentIndex.value]))

function handleEnded() {
  currentIndex.value = (currentIndex.value + 1) % playlist.length
}

function handlePlay() {
  // console.debug(logTime(), 'background-music', { index: currentIndex.value, src: src.value })
}
</script>

<template>
  <audio
    v-show="show"
    class="background-music"
    :src
    :data-index="currentIndex"
    :autoplay
    controls
    preload="auto"
    @play="handlePlay"
    @ended="handleEnded"
  ></audio>
</template>

<style scoped>
.background-music {
  position: absolute;
  z-index: 10;
}
</style>
